/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   City Footer Component that shows top 25 US cities
 */

import { cn } from '@zcode-ui/shadz-ui'
import { TOP_TWENTY_FIVE_USA_CITIES } from '@zcode/nr/es/shared/constants/default_city_groups'
import { MemoAnalyticsTrack } from '@zcode/nr/es/shared/packages/analytics-track'
import { routesConstants } from '@zcode/zumper-routes'
import React from 'react'
import { default as preload } from '../../routes/preload'
import { useAnalyticChannel } from '../AnalyticChannelProvider/useAnalyticChannel'
import { default as PreserveFiltersLinkContainer } from '../PreserveFiltersLink/PreserveFiltersLinkContainer'

const onMouseEnter = () => preload([routesConstants.CURRENT_SEARCH_ROUTE])

interface CityFooterProps {
  hideHeader?: boolean
  className?: string
}

const CityFooter = ({ hideHeader, className }: CityFooterProps) => {
  const { analyticChannel } = useAnalyticChannel()
  const headerText = "We've got Homes and Apartments for Rent in Popular Cities."

  return (
    <div
      className={cn(
        'w-full py-[50px] px-0 bg-transparent',
        hideHeader ? 'min-h-[200px]' : 'min-h-[580px] md:min-h-[340px]',
        className
      )}
    >
      <div className="w-full">
        {!hideHeader && (
          <h2 className="text-3xl sm:text-2xl md:text-3xl font-medium leading-8 sm:leading-6 md:leading-8 mb-6 md:mb-8">
            {headerText}
          </h2>
        )}
        <div className="flex flex-row lg:flex-col items-center lg:h-[180px] justify-between flex-wrap w-full">
          {TOP_TWENTY_FIVE_USA_CITIES.map((city) => (
            <MemoAnalyticsTrack
              action="Footer Link"
              category={analyticChannel}
              key={city.url}
              label={city.name}
              render={({ trackEvent }: { trackEvent: () => void }) => (
                <PreserveFiltersLinkContainer
                  className="city-footer-link"
                  onClick={trackEvent}
                  onMouseEnter={onMouseEnter}
                  to={`/${routesConstants.APTS_BASE_URL}/${city.url}`}
                >
                  {`${city.name} Apartments`}
                </PreserveFiltersLinkContainer>
              )}
              // @ts-expect-error [Property 'renderDeps' does not exist on type]
              renderDeps={[city]}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default CityFooter
